import styled from 'styled-components';

export const Wrapper = styled.div<{ isFullScreenImageModalOpen?: boolean }>`
  position: relative;
  width: ${({ isFullScreenImageModalOpen }) =>
    isFullScreenImageModalOpen ? '85vw' : '100%'};
  height: ${({ isFullScreenImageModalOpen }) =>
    isFullScreenImageModalOpen ? '75vh' : '100%'};
  overflow: ${({ isFullScreenImageModalOpen }) =>
    isFullScreenImageModalOpen ? 'visible' : 'hidden'};
`;

export const Slider = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  z-index: 10;
  -webkit-overflow-scrolling: touch;

  /* hide default scrollbar */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  > div {
    position: relative;
    scroll-snap-align: start;
    flex-shrink: 0;
    padding: 0px 12px;
  }

  > div.fit-cover {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  > div.fit-contain {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
`;

export const Image = styled.img<{ fit: 'cover' | 'contain' }>`
  ${({ fit }) =>
    fit === 'cover'
      ? `
    width: 100%;
    height: 100%;
    object-fit: cover;
  `
      : `
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  `}
`;
